
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"#798F8F","stroke-linecap":"round","stroke-linejoin":"round","d":"M13.502 9.521V5.497a1.33 1.33 0 0 0-.667-1.153L8.169 1.677a1.33 1.33 0 0 0-1.334 0L2.17 4.344a1.33 1.33 0 0 0-.667 1.153v5.333a1.33 1.33 0 0 0 .667 1.153l4.666 2.667a1.33 1.33 0 0 0 1.334 0"}}),_c('path',{attrs:{"stroke":"#798F8F","stroke-linecap":"round","d":"M9.634 10.298a3.552 3.552 0 0 0-5.58 2.772m5.58-5.57a2.157 2.157 0 1 1-4.314 0 2.157 2.157 0 0 1 4.314 0Z"}}),_c('path',{attrs:{"stroke":"#798F8F","stroke-linecap":"round","stroke-linejoin":"round","d":"m15.423 12.31-2.497 1.304-2.514-1.303m0-.342c0-.167.156-.303.349-.303h4.313c.193 0 .349.136.349.303v3.155c0 .168-.156.304-.35.304h-4.312c-.193 0-.35-.136-.35-.304z"}})])
          )
        }
      }
    